export const S3_BUCKET_NAME = "amplify-schedulum-4nkh-sa-schedulumdrivebucket775c-nz7dmja1diio";
export const S3_BUCKET = "https://amplify-schedulum-4nkh-sa-schedulumdrivebucket775c-nz7dmja1diio.s3.us-east-1.amazonaws.com/public/";
export const S3_BUCKET_PRIVATE = "https://amplify-schedulum-4nkh-sa-schedulumdrivebucket775c-nz7dmja1diio.s3.us-east-1.amazonaws.com/private/";
export const DEFAULT_USER_IMAGE = "https://schedulum.org/no-avatar.jpg";
export const POST_IMAGE_TAG = "<!*!_IMG_!*!>";
export const DISPLAY_NEWS_TYPE = "news";
export const PUBLIC_ID = "PUBLIC_OPENSHIFT";
export const POSTS_PER_PAGE = 15;
export const SHIFTS_PER_PAGE = 30;
export const ALLSHIFTS_PER_PAGE = 700; // 25*25=625 ... 25 personnes a + de 4 shifts pas jour pour 1 sem.
export const USERS_PER_PAGE = 26;
export const ALLUSERS_PER_PAGE = 5000;
export const DOCUMENTS_PER_PAGE = 15;
export const REQUESTS_PER_PAGE = 25;
